import {action} from 'typesafe-actions';
import {SelectorData} from './ProductsContext';
import {
  DesignerSettingsCurrency,
  LocaleSettings,
  LogoSettings,
  ProductThemingSettings,
  UrlSettings,
} from '@taopix/taopix-core/dist/types/types';

export enum ProductsActionTypes {
  SET_SELECTOR_DATA = 'SET_SELECTOR_DATA',
  SET_LOADING = 'SET_LOADING',
  SET_LOGO_SETTINGS = 'SET_LOGO_SETTINGS',
  SET_URL_SETTINGS = 'SET_URL_SETTINGS',
  SET_CURRENCY_SETTINGS = 'SET_CURRENCY_SETTINGS',
  SET_LOCALE_SETTINGS = 'SET_LOCALE_SETTINGS',
  SET_DATA_LOADED = 'SET_DATA_LOADED',
  SET_THEMING_SETTINGS = 'SET_THEMING_SETTINGS',
}

export const ProductsActions = {
  setSelectorData: (payload: SelectorData) =>
    action(ProductsActionTypes.SET_SELECTOR_DATA, payload),
  setLoading: (truthy: boolean) => action(ProductsActionTypes.SET_LOADING, truthy),
  setDataLoaded: (truthy: boolean) => action(ProductsActionTypes.SET_DATA_LOADED, truthy),
  setLogoSettings: (settings: LogoSettings) =>
    action(ProductsActionTypes.SET_LOGO_SETTINGS, settings),
  setUrlSettings: (settings: UrlSettings) => action(ProductsActionTypes.SET_URL_SETTINGS, settings),
  setCurrencySettings: (settings: DesignerSettingsCurrency) =>
    action(ProductsActionTypes.SET_CURRENCY_SETTINGS, settings),
  setLocaleSettings: (settings: LocaleSettings) =>
    action(ProductsActionTypes.SET_LOCALE_SETTINGS, settings),
  setThemingSettings: (settings: ProductThemingSettings) =>
    action(ProductsActionTypes.SET_THEMING_SETTINGS, settings),
};
